/**
 * Sleeve product functionality
 */
'use strict';
var util = require('../../util');

var sleeve = {
	data: {
		element: null,
		wrapper: null,
		scrollInstance: null
	},

	init: function () {
		sleeve.data.wrapper = $('.sleeveSelect');
		sleeve.data.element = $('.sleeve');
		sleeve.sleeveElement();
		sleeve.initScroll(sleeve.data.wrapper);
	},

	sleeveElement: function () {
		sleeve.data.element.on('click', function () {
			sleeve.sleeveElementToggle($(this));
		});
	},

	sleeveElementToggle: function (element) {
		element.toggleClass('selected');
		if (sleeve.data.element.hasClass('selected')) {
			sleeve.data.element.removeClass('selected');
			element.addClass('selected');
		}

		sleeve.data.wrapper.trigger('change');
		sleeve.scrollToSelectedElement(element);
	},

	scrollToSelectedElement: function(element) {
		if (!element || !sleeve.data.scrollInstance) {return;}
		sleeve.data.scrollInstance.scrollToElement(element[0], 0, true, false, 300);
	},

	initScroll: function (element) {
		var options = util.iscrollParams();
		options.scrollX = true;
		options.eventPassthrough = 'vertical';

		var innerWrapperWidth = element.find('.iscroll-wrapper').width();
		var outerWrapperWidth = element.width();

		if (innerWrapperWidth > outerWrapperWidth) {
			var smartScroll = new IScroll(element[0], options);
			sleeve.data.scrollInstance = smartScroll;

			var selectedElement = element.find('.sleeve.selected');
			if (selectedElement.length) {
				sleeve.scrollToSelectedElement(selectedElement);
			}
		}
	}

};
module.exports = sleeve;